import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`submission-actions{margin-top:var(--layout-margin-between-text-content);gap:var(--layout-margin-between-buttons);flex-wrap:wrap;display:flex}`);